export default "/images/vendor/flag-icon-css/flags/1x1/pn.svg?ab7259a94ec182c05827fd8bd1a3e445";